module.exports = __webpack_public_path__ + "img/page智慧校园.37183505.png";